import { Stack, StackProps, Typography } from '@mui/material';

import { HighLightHorizontal } from '@/assets/icons';

export interface ProductCardProps extends StackProps {
  name: string;
  decs: string;
  highlightColor?: string;
  image?: string;
  children?: React.ReactNode;
}

export const ProductCard = ({ name, decs, image, children, highlightColor }: ProductCardProps) => {
  return (
    <Stack
      position={'relative'}
      bgcolor={'#FFFFFF0D'}
      width={'100%'}
      height={'100%'}
      padding={{ xs: '24px', sm: '40px' }}
      sx={{
        clipPath: {
          xs: 'polygon(10% 0%, 100% 0, 100% 91%, 90% 100%, 0% 100%, 0 8%)',
          sm: 'polygon(8% 0%, 100% 0, 100% 90%, 93% 100%, 0% 100%, 0 10%)',
        },
        background:
          'linear-gradient(135deg, rgba(225, 225, 225, 0.85) 0%, rgba(255, 255, 255, 0.05) 25%, rgba(255, 255, 255, 0.05) 50%, rgba(255, 255, 255, 0.05) 75%, rgba(255, 255, 255, 0.05) 100%)',
      }}>
      <Stack
        top={'3px'}
        left={'3px'}
        width={'calc(100% - 6px)'}
        height={'calc(100% - 6px)'}
        position={'absolute'}
        bgcolor={'#060912'}
        sx={{
          clipPath: {
            xs: 'polygon(10% 0%, 100% 0, 100% 91%, 90% 100%, 0% 100%, 0 8%)',
            sm: 'polygon(8% 0%, 100% 0, 100% 90%, 93% 100%, 0% 100%, 0 10%)',
          },
        }}
      />

      <Stack gap={{ xs: 2, sm: 3 }} direction={{ xs: 'column', sm: 'row' }} alignItems={'flex-start'}>
        {image && (
          <Stack
            zIndex={2}
            width={{ xs: '124px', sm: '280px' }}
            height={{ xs: '124px', sm: '280px' }}
            sx={{
              background: `url(${image})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
        )}
        <Stack gap={{ xs: 2, sm: 3 }} alignItems={'flex-start'} width={'100%'} zIndex={2}>
          <Typography
            component={'h3'}
            zIndex={10}
            variant={'headLarge1'}
            fontSize={{ xs: '18px', sm: '24px' }}
            lineHeight={{ xs: '100%', sm: '32px' }}
            color={'#FFFFFF'}>
            {name}
          </Typography>

          <HighLightHorizontal width={'65px'} height={'10px'} color={highlightColor} />

          <Typography
            fontSize={{ xs: '14px', md: '18px' }}
            variant={'bodyLarge'}
            color={'#FFFFFF'}
            whiteSpace={'pre-line'}
            className={'mix-blend'}>
            {decs}
          </Typography>

          {children}
        </Stack>
      </Stack>
    </Stack>
  );
};
